@let comp = company();
<footer class="bg-gray-900 text-gray-300 py-16 mt-auto">
  <div class="max-w-7xl mx-auto px-6">
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 mb-12"
    >
      <!-- Company Info -->
      <div class="flex flex-col">
        <div class="flex items-center gap-2 mb-6">
          @if (comp?.logoUrl) {
            <img
              [src]="comp?.logoUrl"
              [alt]="(comp?.name || 'Compañía') + ' Logo'"
              class="h-32 w-auto"
            />
          }
        </div>
        <p class="text-sm leading-relaxed mb-6 max-w-xs">
          Tu tienda de confianza para repuestos automotrices de calidad. Más de
          15 años de experiencia en el mercado.
        </p>
      </div>

      <!-- Quick Links -->
      <div class="flex flex-col">
        <h4 class="text-white text-lg font-semibold m-0 mb-6">
          Enlaces Rápidos
        </h4>
        <ul class="list-none p-0 m-0 flex flex-col gap-3">
          <li>
            <a
              routerLink="/"
              class="text-inherit no-underline text-sm transition-colors duration-200 hover:text-[var(--mat-sys-secondary)]"
              >Inicio</a
            >
          </li>
          <li>
            <a
              routerLink="/catalog"
              class="text-inherit no-underline text-sm transition-colors duration-200 hover:text-[var(--mat-sys-secondary)]"
              >Catálogo</a
            >
          </li>
          <li>
            <a
              routerLink="/terms-and-conditions"
              class="text-inherit no-underline text-sm transition-colors duration-200 hover:text-[var(--mat-sys-secondary)]"
              >Términos y Condiciones</a
            >
          </li>
          <li>
            <a
              routerLink="/privacy-policies"
              class="text-inherit no-underline text-sm transition-colors duration-200 hover:text-[var(--mat-sys-secondary)]"
              >Políticas de Privacidad</a
            >
          </li>
        </ul>
      </div>

      <!-- Contact Info -->
      <div class="flex flex-col">
        <h4 class="text-white text-lg font-semibold m-0 mb-6">Contacto</h4>
        <ul class="list-none p-0 m-0 flex flex-col gap-4">
          @if (comp?.formattedAddress) {
            <li class="flex items-start gap-3 text-sm">
              <mat-icon
                aria-hidden="true"
                class="text-[var(--mat-sys-secondary)] mt-0.5 text-xl h-5 w-5"
                >location_on</mat-icon
              >
              <a
                [href]="googleMapsUrl()"
                target="_blank"
                class="text-inherit no-underline transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                <span class="leading-relaxed">{{
                  comp?.formattedAddress
                }}</span>
              </a>
            </li>
          }
          @if (comp?.phoneNumber) {
            <li class="flex items-start gap-3 text-sm">
              <mat-icon
                aria-hidden="true"
                class="text-[var(--mat-sys-secondary)] mt-0.5 text-xl h-5 w-5"
                >phone</mat-icon
              >
              <a
                [href]="whatsappUrl()"
                target="_blank"
                class="text-inherit no-underline transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                <span class="leading-relaxed">{{ comp?.phoneNumber }}</span>
              </a>
            </li>
          }

          @if (comp?.email) {
            <li class="flex items-start gap-3 text-sm">
              <mat-icon
                aria-hidden="true"
                class="text-[var(--mat-sys-secondary)] mt-0.5 text-xl h-5 w-5"
                >mail</mat-icon
              >
              <a
                [href]="'mailto:' + comp!.email"
                class="text-inherit no-underline transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                <span class="leading-relaxed">{{ comp?.email }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="border-t border-gray-800 pt-8 text-center">
      <p class="text-sm m-0 text-gray-400">
        &copy; {{ currentYear }} {{ comp?.name }}. Todos los derechos
        reservados.
      </p>
    </div>
  </div>
</footer>
